import React from 'react';
import { CheckIcon } from 'lucide-react';
interface SymptomChipProps {
  label: string;
  selected: boolean;
  onToggle: () => void;
}
export function SymptomChip({
  label,
  selected,
  onToggle
}: SymptomChipProps) {
  return <button type="button" onClick={onToggle} aria-pressed={selected} className={`inline-flex items-center gap-2 rounded-brand border px-4 py-2.5 text-left text-[0.9375rem] leading-snug transition-[background-color,border-color,color,transform] duration-[120ms] ease-brand active:scale-[0.98] ${selected ? 'border-brick bg-brick text-cream' : 'border-ink/20 bg-cream-light text-ink hover:border-ink/45'}`} data-id="element-105" data-mp="2dn9ixr8vm8x5">
      {selected && <CheckIcon className="h-4 w-4 shrink-0" strokeWidth={2} aria-hidden="true" data-id="element-106" data-mp="1pyp4jzzbnuk2" />}
      {label}
    </button>;
}